var collapsibleListItemStyles = {"titleContainer":"_8lTe5","title":"RIoRk","content":"_2K7jC","expandIcon":"_5Tb9Q","dndIcon":"tcjH1","RTL":"nncbA","LTR":"mmUpX","itemContainer":"fU3Fl","mouseDown":"ujin0","innerEditor":"MikhB","item":"YQL8l","floatingAddPluginMenuWrapper":"NuQV7"};

export { collapsibleListItemStyles as c };
